import get from "lodash/get";

const geometryConfig = {
    // fer: {
    //     displayName: "FER",
    //     geojsonUrl:
    //         process.env.PUBLIC_URL +
    //         "/data/fer-generalised-simplified-0.008-topo.json",
    //     idSelector: feature => get(feature, ["properties", "ID"]),
    //     idCol: "ID",
    //     nameSelector: feature => get(feature, ["properties", "FER_NAME"]),
    //     topologyObjectsName: "fer-generalised-simplified-0",
    // },
    // regions: {
    //     displayName: "DPC Regions",
    //     geojsonUrl:
    //         process.env.PUBLIC_URL +
    //         "/data/dpc-regions-generalised-simplified-0.0008-topo.json",
    //     idSelector: feature => get(feature, ["properties", "CADID"]),
    //     idCol: "CADID",
    //     nameSelector: feature => get(feature, ["properties", "REGION"]),
    //     topologyObjectsName: "dpc-regions-generalised-simplified-0",
    // },
    // lga: {
    //     displayName: "LGA",
    //     geojsonUrl:
    //         process.env.PUBLIC_URL +
    //         "/data/lga-nsw-2016-simplified-0.0008-topo.json",
    //     idSelector: feature => get(feature, ["properties", "LGA_CODE16"]),
    //     idCol: "LGA_CODE16",
    //     nameSelector: feature => get(feature, ["properties", "LGA_NAME16"]),
    //     topologyObjectsName: "lga-nsw-2016-simplified-0",
    // },
    // auslga: {
    //     displayName: "AUSLGA",
    //     geojsonUrl:
    //         process.env.PUBLIC_URL +
    //         "/data/aus_lga.json",
    //     idSelector: feature => get(feature, ["properties", "Name"]),
    //     idCol: "Name",
    //     nameSelector: feature => get(feature, ["properties", "Name"]),
    //     topologyObjectsName: "aus_lga",
    // },
    // ssc: {
    //     displayName: "State Suburbs",
    //     geojsonUrl:
    //         process.env.PUBLIC_URL +
    //         "/data/ssc-topo-smaller.json",
    //     idSelector: feature => get(feature, ["properties", "SSC_CODE16"]),
    //     idCol: "SSC_CODE16",
    //     nameSelector: feature => get(feature, ["properties", "SSC_NAME16"]),
    //     topologyObjectsName: "ssc-geojson",
    // },
    // electorates: {
    //     displayName: "Electorates",
    //     geojsonUrl:
    //         process.env.PUBLIC_URL +
    //         "/data/sed-nsw-2016-simplified-0.0008.json",
    //     idSelector: feature => get(feature, ["properties", "SED_CODE16"]),
    //     idCol: "SED_CODE16",
    //     nameSelector: feature => get(feature, ["properties", "SED_NAME16"]),
    //     topologyObjectsName: "sed-nsw-2016-simplified-0",
    // },
    postcode: {
        displayName: "Postcodes",
        geojsonUrl:
            process.env.PUBLIC_URL +
            "/data/postcode-map-topo.json",
        idSelector: feature => get(feature, ["properties", "POA_CODE16"]),
        idCol: "POA_CODE16",
        nameSelector: feature => get(feature, ["properties", "POA_NAME16"]),
        topologyObjectsName: "postcode-map",
    },
    postcodeNsw: {
        displayName: "NSW Postcodes",
        geojsonUrl:
            process.env.PUBLIC_URL +
            "/data/postcode-nsw.json",
        idSelector: feature => get(feature, ["properties", "POA_CODE16"]),
        idCol: "POA_CODE16",
        nameSelector: feature => get(feature, ["properties", "POA_NAME16"]),
        topologyObjectsName: "postcode-nsw",
    },
};

export default geometryConfig;



// WEBPACK FOOTER //
// ./src/modules/geometryConfigs.js